import { joinURL } from "../hype/helpers/url";
import { chatflowURL, chatflowApiURL, gatewayURL } from "../config";

/**
 * Kong / gateway paths (typical):
 *   /chatflow          → admin UI + static (iframe editor)
 *   /api/chatflow/rest → REST API (same as chatflow service /rest/*)
 *
 * config.json:
 *   chatflowURL     — admin base (required for editor iframe)
 *   chatflowApiURL  — REST base including /rest if Kong exposes it (optional)
 */
function trimBase(url) {
  return (url || "").replace(/\/$/, "");
}

const adminBase = trimBase(chatflowURL || (gatewayURL ? joinURL(gatewayURL, "chatflow") : ""));

let restBase = trimBase(chatflowApiURL);
if (!restBase && gatewayURL) {
  restBase = trimBase(joinURL(gatewayURL, "api/chatflow/rest"));
}
if (!restBase && adminBase) {
  restBase = trimBase(joinURL(adminBase, "rest"));
}

export default {
  baseURL: adminBase,
  restUrl: restBase,
  adminEmbedUrl(flowId) {
    if (!adminBase || !flowId) return "";
    return `${adminBase}/admin/?embed=1&flowId=${encodeURIComponent(flowId)}`;
  },
  isConfigured() {
    return Boolean(adminBase && restBase);
  },
};
